<template>
  <div />
</template>

<script>
export default {
    name: 'QRCodeDownload',
    created() {
        const u = window.navigator.userAgent.toLowerCase();
        if (/android/.test(u)) {
            //安卓设备
            window.location.replace('https://play.google.com/store/apps/details?id=com.house730.pms');
        } else if (/iphone|ipad|ipod/.test(u)) {
            //ios设备
            window.location.replace('https://apps.apple.com/hk/app/id1492668798');
        }
    }
};
</script>

<style scoped></style>
